import clsx from "clsx";
import Divider from "@mui/material/Divider";
import { useFormContext } from "react-hook-form";
import CField from "$forms/CField";
import { Text } from "$components";
import useAuth from "$hooks/useAuth";
import { useStyles } from "../../styles/DeliveryPicker.styles";
import FileUploader from "$components/FileUploader/FileUploader";
import { useDeliveryEDBContext } from "$containers/EDB/ProfileEDB/context/DeliveryContext";

export default function AdditionalInfo() {
  const classes = useStyles();
  const { isAdmin } = useAuth();

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { dockyard } = useDeliveryEDBContext();

  return (
    <>
      <div className={classes.contentStep3}>
        <div className={classes.contentStep3Title}>
          <Text className={classes.subtitle}>Code analytique</Text>
        </div>
        <div className={clsx(classes.contentStep3Content, classes.flex)}>
          <CField
            control={control}
            label="Code analytique"
            name="analyticCode"
            error={errors.analyticCode}
          />
        </div>
      </div>
      <Divider className={classes.divider} />
      <div className={classes.contentStep3}>
        <div className={classes.contentStep3Title}>
          <Text className={classes.subtitle}>Notes, contraintes</Text>
        </div>
        <div className={clsx(classes.contentStep3Content, classes.flex)}>
          <CField
            control={control}
            name="notes"
            error={errors.adress}
            multiline
            rows={4}
            placeholder="Tapez vos notes, contraintes, ..."
            variant="outlined"
          />
        </div>
      </div>
      <Divider className={classes.divider} />
      <div className={classes.contentStep3Title}>
        <Text className={classes.subtitle}>Pièces jointes</Text>
      </div>
      <CField
        control={control}
        disabled={!isAdmin()}
        name="medias"
        error={errors.medias}
      >
        {(props) => (
          <FileUploader
            company={dockyard?.company?._id}
            type="edb"
            {...props}
            isAdmin={isAdmin()}
            // isLargeVersion
          />
        )}
      </CField>
    </>
  );
}
